import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ActivityPage, activitySearchSchema } from '@/features/activity';

export const Route = createFileRoute('/_authed/_active/org/activity')({
  staticData: { crumb: 'common:nav.activity', tours: ['org.activity'] },
  validateSearch: activitySearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'audit.read');
  },
  component: ActivityPage,
});
